<template>
  <nut-uploader :multiple="multiple" :maximum="limit" :accept="accept"
                v-model:file-list="uploadedFiles"
                @delete="handleUploadImageRemove"
                @success="handleImageUploadSuccess"
                :maximize="1024 * 1024 * 20"
                :before-xhr-upload="uploadRequest"></nut-uploader>
</template>

<script>
import api from "@/api";
// 后端上传
export default {
  name: "OssUploader",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    files: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      ossInitState: false,
      uploading: false,
      ossDomain: null,
      ossFolder: null,
      uploadedFiles: [],
      uploaded:[],
    }
  },
  watch: {
    files() {
      this.syncUploaded();
    }
  },
  methods: {
    syncUploaded() {
      for (let up of this.files) {
        this.uploaded.push(up);
        this.uploadedFiles.push({
          name: up,
          url: up,
          status: 'success',
          message: '上传成功',
          type: 'image'
        });
      }
    },
    uploadRequest(xhr, options) {
        let file = options.sourceFile; // 拿到 file
        // 上传文件
        api.uploadFile({files:file}).then(res=>{
          const result = {
            name:res[0].filename,
            url:res[0].realname
          }
          options.onSuccess(result)
        }).catch(err=>{
          console.log("err",err)
          options.onError("上传失败")
        })
    },
    handleImageUploadSuccess(resp) {
      this.uploaded.push(resp.responseText.url);
      this.$emit('onUploadedFiles', this.uploaded);
    },
    handleUploadImageRemove(del) {
      this.uploaded.splice(del.index, 1);
      this.$emit('onUploadedFiles', this.uploaded);
    }
  },
  mounted() {
    this.syncUploaded();
  }
}
</script>

<style scoped>

</style>